import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import styles from '../../styles/LoadingSkeletons.module.css';

const skeletonSx = { bgcolor: 'rgba(255, 255, 255, 0.08)' };

const MobileGameRowSkeleton = () => (
  <div className={styles.mobileRowSkeleton} aria-hidden="true">
    <Skeleton variant="text" width="70%" height={22} sx={skeletonSx} />
    <Skeleton variant="text" width="45%" height={18} sx={{ ...skeletonSx, mt: 1 }} />
    <Skeleton variant="text" width="35%" height={16} sx={{ ...skeletonSx, mt: 1.5 }} />
  </div>
);

export const MobileGameRowSkeletonList = ({ count = 5 }) => (
  <div
    className={styles.mobileRowList}
    role="status"
    aria-live="polite"
    aria-label="Loading games"
  >
    {Array.from({ length: count }, (_, index) => (
      <MobileGameRowSkeleton key={`mobile-game-skeleton-${index}`} />
    ))}
  </div>
);

MobileGameRowSkeletonList.propTypes = {
  count: PropTypes.number,
};

export default MobileGameRowSkeletonList;
